import tw, { styled } from 'twin.macro';

export const TitleBar = styled.div`
  ${tw`w-full pt-6 bg-primary-300 shadow-md md:px-4 md:px-16`}
  margin-top: 112px;
`;
